import TableRef from './TableRef';
import ViewRef from './ViewRef';
import SqlRef from './SqlRef';
import CsvRef from './CsvRef';

class TovBuilder {
  static build(tovFromServer) {
    if (tovFromServer._schema) {
      return new TableRef(tovFromServer._schema, tovFromServer._name);
    }
    if (tovFromServer._series) {
      return ViewRef.build(tovFromServer);
    }
    if (tovFromServer._discriminator === 'sql') {
      return new SqlRef();
    }
    if (tovFromServer._discriminator === 'csv') {
      return new CsvRef();
    }
    throw new Error(`Unexpected table ref type: ${tovFromServer}`);
  }
}

export default TovBuilder;
